import React from 'react';
import classes from '../../bidAnalysisTemplate.module.scss';

interface SubSectionHeaderProps {
  title: string;
  isExpanded: boolean;
  onToggle: () => void;
  /** Rendered inline immediately after the title text (e.g. an info icon). */
  titleSuffix?: React.ReactNode;
  children?: React.ReactNode;
}

export const SubSectionHeader: React.FC<SubSectionHeaderProps> = ({
  title,
  isExpanded,
  onToggle,
  titleSuffix,
  children,
}) => {
  return (
    <div className={classes.subSectionHeader} onClick={onToggle}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <h3 style={{ margin: 0 }}>{title}</h3>
        {titleSuffix && (
          <div onClick={e => e.stopPropagation()}>{titleSuffix}</div>
        )}
      </div>
      <div
        style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
        onClick={e => e.stopPropagation()}
      >
        {children}
        <i className={`pi ${isExpanded ? 'pi-chevron-up' : 'pi-chevron-down'}`}></i>
      </div>
    </div>
  );
};
